import Vue from "vue";
import Router from "vue-router";
import Middlewares from "./middlewares/index";

Vue.use(Router);


const routes = [
  {
    path: "/",
    redirect: "/dashboard",
    component: () => import("@/view/layout/Layout"),
    children: [
      {
        path: "/dashboard",
        name: "dashboard",
        component: () => import("@/view/pages/Dashboard.vue"),
        meta: { middleware: [Middlewares.auth] }
      },
      {
        path: "/account",
        name: "Account",
        component: () => import("@/view/pages/user/Account.vue"),
        meta: { middleware: [Middlewares.auth] }
      },
      {
        path: "/pages",
        name: "Pages",
        component: () => import("@/view/pages/content/Pages.vue"),
        meta: { middleware: [Middlewares.auth] }
      },
      {
        path: "/home-page",
        name: "HomePage",
        component: () => import("@/view/pages/content/HomePage.vue"),
        meta: { middleware: [Middlewares.auth] }
      },
      {
        path: "/edit-page/:id",
        name: "PageEdit",
        component: () => import("@/view/pages/content/EditPage.vue"),
        meta: { middleware: [Middlewares.auth] }
      },
      {
        path: "/categories",
        name: "Categories",
        component: () => import("@/view/pages/shop/Categories.vue"),
        meta: { middleware: [Middlewares.auth] }
      },
      {
        path: "/archive-categories",
        name: "ArchiveCategories",
        component: () => import("@/view/pages/shop/ArchiveCategories.vue"),
        meta: { middleware: [Middlewares.auth] }
      },

      {
        path: "/category/:action/:type/:id?",
        name: "FormCategory",
        component: () => import("@/view/pages/shop/FormCategory.vue"),
        meta: { middleware: [Middlewares.checkPermissions], permissions: ['view-dashboard'] }
      },

      {
        path: "/add-category",
        name: "AddCategories",
        component: () => import("@/view/pages/shop/AddCategory.vue"),
        meta: { middleware: [Middlewares.auth] }
      },
      {
        path: "/edit-category/:id",
        name: "EditCategories",
        component: () => import("@/view/pages/shop/EditCategory.vue"),
        meta: { middleware: [Middlewares.auth] }
      },
      {
        path: "/edit-sub-category/:id",
        name: "EditSubCategories",
        component: () => import("@/view/pages/shop/EditSubCategory.vue"),
        meta: { middleware: [Middlewares.auth] }
      },

      {
        path: "/products/:page?",
        name: "Products",
        component: () => import("@/view/pages/shop/Products.vue"),
        meta: { middleware: [Middlewares.checkPermissions], permissions: ['view-dashboard'] }
      },

      {
        path: "/archive-products/:page?",
        name: "ArchiveProducts",
        component: () => import("@/view/pages/shop/ArchiveProducts.vue"),
        meta: { middleware: [Middlewares.checkPermissions], permissions: ['view-dashboard'] }
      },

      {
        path: "/product/:action/:id?",
        name: "FormProduct",
        component: () => import("@/view/pages/shop/FormProducts.vue"),
        meta: { middleware: [Middlewares.checkPermissions], permissions: ['view-dashboard'] }
      },

      {
        path: "/attributes",
        name: "Attributes",
        component: () => import("@/view/pages/shop/Attributes.vue"),
        meta: { middleware: [Middlewares.checkPermissions], permissions: ['view-dashboard'] }
      },

      {
        path: "/add-attribute",
        name: "AddAttribute",
        component: () => import("@/view/pages/shop/AddAttrebutes.vue"),
        meta: { middleware: [Middlewares.checkPermissions], permissions: ['view-dashboard'] }
      },

      {
        path: "/edit-attribute/:id",
        name: "EditAttribute",
        component: () => import("@/view/pages/shop/EditAttrebutes.vue"),
        meta: { middleware: [Middlewares.checkPermissions], permissions: ['view-dashboard'] }
      },

      {
        path: "/orders/:page?",
        name: "Orders",
        component: () => import("@/view/pages/orders/Orders.vue"),
        meta: { middleware: [Middlewares.checkPermissions], permissions: ['view-dashboard'] }
      },

      {
        path: "/order/:id",
        name: "OrderDetails",
        component: () => import("@/view/pages/orders/OrderDetails.vue"),
        meta: { middleware: [Middlewares.checkPermissions], permissions: ['view-dashboard'] }
      },

      {
        path: "/order-tables/:page?",
        name: "OrderTables",
        component: () => import("@/view/pages/order_table/orderTables.vue"),
        meta: { middleware: [Middlewares.checkPermissions], permissions: ['view-dashboard'] }
      },

      {
        path: "/order-table/:id",
        name: "OrderTable",
        component: () => import("@/view/pages/order_table/orderTable.vue"),
        meta: { middleware: [Middlewares.checkPermissions], permissions: ['view-dashboard'] }
      },

      {
        path: "/archive-orders/:page?",
        name: "ArchiveOrder",
        component: () => import("@/view/pages/orders/ArchiveOrders.vue"),
        meta: { middleware: [Middlewares.checkPermissions], permissions: ['view-dashboard'] }
      },

      {
        path: "/accounts/:page?",
        name: "Accounts",
        component: () => import("@/view/pages/user/Accounts.vue"),
        meta: { middleware: [Middlewares.checkPermissions], permissions: ['view-dashboard'] }
      },


      {
        path: "/edit-accounts/:id",
        name: "EditAccount",
        component: () => import("@/view/pages/user/EditAccount.vue"),
        meta: { middleware: [Middlewares.checkPermissions], permissions: ['view-dashboard'] }
      },



      {
        path: "/clients/:page?",
        name: "Clients",
        component: () => import("@/view/pages/clients/Clients.vue"),
        meta: { middleware: [Middlewares.checkPermissions], permissions: ['view-dashboard'] }
      },

      {
        path: "/client/:id",
        name: "Client",
        component: () => import("@/view/pages/clients/Client.vue"),
        meta: { middleware: [Middlewares.checkPermissions], permissions: ['view-dashboard'] }
      },

      {
        path: "/coupons",
        name: "Coupons",
        component: () => import("@/view/pages/coupons/Coupons.vue"),
        meta: { middleware: [Middlewares.checkPermissions], permissions: ['view-dashboard'] }
      },

      {
        path: "/files/:page?",
        name: "Files",
        component: () => import("@/view/pages/files/Files.vue"),
        meta: { middleware: [Middlewares.checkPermissions], permissions: ['view-dashboard'] }
      },

      {
        path: "/delivery-cities/:page?",
        name: "DeliveryCities",
        component: () => import("@/view/pages/cities/DeliveryCities.vue"),
        meta: { middleware: [Middlewares.checkPermissions], permissions: ['view-dashboard'] }
      },

      {
        path: "/site-settings",
        name: "SiteSettings",
        component: () => import("@/view/pages/settings/SiteSettings.vue"),
        meta: { middleware: [Middlewares.checkPermissions], permissions: ['view-dashboard'] }
      },

      {
        path: "/builder",
        name: "builder",
        component: () => import("@/view/pages/Builder.vue")
      },

      {
        path: "/vue-bootstrap",
        name: "vue-bootstrap",
        component: () =>
            import("@/view/pages/vue-bootstrap/VueBootstrap.vue"),
        children: [
          {
            path: "alert",
            name: "vue-bootstrap-alert",
            component: () => import("@/view/pages/vue-bootstrap/Alert.vue")
          },
          {
            path: "badge",
            name: "vue-bootstrap-badge",
            component: () => import("@/view/pages/vue-bootstrap/Badge.vue")
          },
          {
            path: "button",
            name: "vue-bootstrap-button",
            component: () => import("@/view/pages/vue-bootstrap/Button.vue")
          },
          {
            path: "button-group",
            name: "vue-bootstrap-button-group",
            component: () =>
                import("@/view/pages/vue-bootstrap/ButtonGroup.vue")
          },
          {
            path: "button-toolbar",
            name: "vue-bootstrap-button-toolbar",
            component: () =>
                import("@/view/pages/vue-bootstrap/ButtonToolbar.vue")
          },
          {
            path: "card",
            name: "vue-bootstrap-card",
            component: () => import("@/view/pages/vue-bootstrap/Card.vue")
          },
          {
            path: "carousel",
            name: "vue-bootstrap-carousel",
            component: () => import("@/view/pages/vue-bootstrap/Carousel.vue")
          },
          {
            path: "collapse",
            name: "vue-bootstrap-collapse",
            component: () => import("@/view/pages/vue-bootstrap/Collapse.vue")
          },
          {
            path: "dropdown",
            name: "vue-bootstrap-dropdown",
            component: () => import("@/view/pages/vue-bootstrap/Dropdown.vue")
          },
          {
            path: "embed",
            name: "vue-bootstrap-embed",
            component: () => import("@/view/pages/vue-bootstrap/Embed.vue")
          },
          {
            path: "form",
            name: "vue-bootstrap-form",
            component: () => import("@/view/pages/vue-bootstrap/Form.vue")
          },
          {
            path: "form-checkbox",
            name: "vue-bootstrap-form-checkbox",
            component: () =>
                import("@/view/pages/vue-bootstrap/FormCheckbox.vue")
          },
          {
            path: "form-file",
            name: "vue-bootstrap-form-file",
            component: () => import("@/view/pages/vue-bootstrap/FormFile.vue")
          },
          {
            path: "form-group",
            name: "vue-bootstrap-form-group",
            component: () =>
                import("@/view/pages/vue-bootstrap/FormGroup.vue")
          },
          {
            path: "form-input",
            name: "vue-bootstrap-form-input",
            component: () =>
                import("@/view/pages/vue-bootstrap/FormInput.vue")
          },
          {
            path: "form-radio",
            name: "vue-bootstrap-form-radio",
            component: () =>
                import("@/view/pages/vue-bootstrap/FormRadio.vue")
          },
          {
            path: "form-select",
            name: "vue-bootstrap-form-select",
            component: () =>
                import("@/view/pages/vue-bootstrap/FormSelect.vue")
          },
          {
            path: "form-textarea",
            name: "vue-bootstrap-form-textarea",
            component: () =>
                import("@/view/pages/vue-bootstrap/FormTextarea.vue")
          },
          {
            path: "image",
            name: "vue-bootstrap-image",
            component: () => import("@/view/pages/vue-bootstrap/Image.vue")
          },
          {
            path: "input-group",
            name: "vue-bootstrap-input-group",
            component: () =>
                import("@/view/pages/vue-bootstrap/InputGroup.vue")
          },
          {
            path: "jumbotron",
            name: "vue-bootstrap-jumbotron",
            component: () =>
                import("@/view/pages/vue-bootstrap/Jumbotron.vue")
          },
          {
            path: "layout-grid-system",
            name: "vue-bootstrap-layout-grid-system",
            component: () =>
                import("@/view/pages/vue-bootstrap/LayoutGridSystem.vue")
          },
          {
            path: "link",
            name: "vue-bootstrap-link",
            component: () => import("@/view/pages/vue-bootstrap/Link.vue")
          },
          {
            path: "list-group",
            name: "vue-bootstrap-list-group",
            component: () =>
                import("@/view/pages/vue-bootstrap/ListGroup.vue")
          },
          {
            path: "media",
            name: "vue-bootstrap-media",
            component: () => import("@/view/pages/vue-bootstrap/Media.vue")
          },
          {
            path: "modal",
            name: "vue-bootstrap-modal",
            component: () => import("@/view/pages/vue-bootstrap/Modal.vue")
          },
          {
            path: "nav",
            name: "vue-bootstrap-nav",
            component: () => import("@/view/pages/vue-bootstrap/Nav.vue")
          },
          {
            path: "navbar",
            name: "vue-bootstrap-navbar",
            component: () => import("@/view/pages/vue-bootstrap/Navbar.vue")
          },
          {
            path: "pagination",
            name: "vue-bootstrap-pagination",
            component: () =>
                import("@/view/pages/vue-bootstrap/Pagination.vue")
          },
          {
            path: "pagination-nav",
            name: "vue-bootstrap-pagination-nav",
            component: () =>
                import("@/view/pages/vue-bootstrap/PaginationNav.vue")
          },
          {
            path: "popover",
            name: "vue-bootstrap-popover",
            component: () => import("@/view/pages/vue-bootstrap/Popover.vue")
          },
          {
            path: "progress",
            name: "vue-bootstrap-progress",
            component: () => import("@/view/pages/vue-bootstrap/Progress.vue")
          },
          {
            path: "spinner",
            name: "vue-bootstrap-spinner",
            component: () => import("@/view/pages/vue-bootstrap/Spinner.vue")
          },
          {
            path: "table",
            name: "vue-bootstrap-table",
            component: () => import("@/view/pages/vue-bootstrap/Table.vue")
          },
          {
            path: "tabs",
            name: "vue-bootstrap-tabs",
            component: () => import("@/view/pages/vue-bootstrap/Tabs.vue")
          },
          {
            path: "toasts",
            name: "vue-bootstrap-toasts",
            component: () => import("@/view/pages/vue-bootstrap/Toasts.vue")
          },
          {
            path: "tooltip",
            name: "vue-bootstrap-tooltip",
            component: () => import("@/view/pages/vue-bootstrap/Tooltip.vue")
          }
        ]
      },
      {
        path: "/wizard",
        name: "wizard",
        component: () => import("@/view/pages/wizard/Wizard.vue"),
        children: [
          {
            path: "wizard-1",
            name: "wizard-1",
            component: () => import("@/view/pages/wizard/Wizard-1.vue")
          },
          {
            path: "wizard-2",
            name: "wizard-2",
            component: () => import("@/view/pages/wizard/Wizard-2.vue")
          },
          {
            path: "wizard-3",
            name: "wizard-3",
            component: () => import("@/view/pages/wizard/Wizard-3.vue")
          },
          {
            path: "wizard-4",
            name: "wizard-4",
            component: () => import("@/view/pages/wizard/Wizard-4.vue")
          }
        ]
      }
    ]
  },
  {
    path: "/error",
    name: "error",
    component: () => import("@/view/pages/error/Error.vue"),
    children: [
      {
        path: "error-1",
        name: "error-1",
        component: () => import("@/view/pages/error/Error-1.vue")
      },
      {
        path: "error-2",
        name: "error-2",
        component: () => import("@/view/pages/error/Error-2.vue")
      },
      {
        path: "error-3",
        name: "error-3",
        component: () => import("@/view/pages/error/Error-3.vue")
      },
      {
        path: "error-4",
        name: "error-4",
        component: () => import("@/view/pages/error/Error-4.vue")
      },
      {
        path: "error-5",
        name: "error-5",
        component: () => import("@/view/pages/error/Error-5.vue")
      },
      {
        path: "error-6",
        name: "error-6",
        component: () => import("@/view/pages/error/Error-6.vue")
      }
    ]
  },
  {
    path: "/",
    component: () => import("@/view/pages/auth/Auth"),
    children: [
      {
        name: "login",
        path: "/login",
        component: () => import("@/view/pages/auth/Login"),
        meta: { middleware: [Middlewares.guest] }
      },
      {
        name: "register",
        path: "/register",
        component: () => import("@/view/pages/auth/Register"),
        meta: { middleware: [Middlewares.guest] }
      }
    ]
  },
  {
    path: "*",
    redirect: "/404"
  },
  {
    // the 404 route, when none of the above matches
    path: "/404",
    name: "404",
    component: () => import("@/view/pages/error/Error-1.vue")
  }
];

const router = new Router({

  base: '/',
  mode: 'history',
  history: true,

  routes
});


function nextCheck(context, middleware, index) {
  const nextMiddleware = middleware[index];

  if (!nextMiddleware) return context.next;

  return (...parameters) => {
    context.next(...parameters);
    const nextMidd = nextCheck(context, middleware, index + 1)

    nextMiddleware({...context, next: nextMidd})
  }
}

router.beforeEach((to, from, next) => {
  if (to.meta.middleware){
    const middleware = Array.isArray(to.meta.middleware) ? to.meta.middleware : [to.meta.middleware];
    const ctx = {
      from,
      next,
      router,
      to
    };
    const nextMiddleware = nextCheck(ctx, middleware, 1);
    return middleware[0]({...ctx, next: nextMiddleware});
  }
  return next();
});

export default router;